import { normalizeStyle } from './normalize-styles'

// helper to merge styles safely
const mergeStyles = (...styles) =>
  normalizeStyle(Object.assign({}, ...[].concat(...styles).filter(Boolean)))

// view component
export const View = ({ style = {}, children, className = '', ...rest }) => (
  <div className={className} style={mergeStyles(style)} {...rest}>
    {children}
  </div>
)

// text component
export const Text = ({ style = {}, children, className = '', ...rest }) => (
  <span className={className} style={mergeStyles(style)} {...rest}>
    {children}
  </span>
)

// image component
export const Image = ({
  src,
  style = {},
  className = '',
  alt = '',
  ...rest
}) => {
  const resolvedSrc = typeof src === 'object' ? src.uri : src

  return (
    <img
      src={resolvedSrc}
      alt={alt}
      className={className}
      style={mergeStyles(style)}
      {...rest}
    />
  )
}

// link component
export const Link = ({
  src,
  children,
  style = {},
  className = '',
  ...rest
}) => (
  <a href={src} className={className} style={mergeStyles(style)} {...rest}>
    {children}
  </a>
)

// document/page placeholders
export const Document = ({ children }) => <>{children}</>
export const Page = ({ children, style = {}, className = '', ...rest }) => (
  <div className={className} style={mergeStyles(style)} {...rest}>
    {children}
  </div>
)

// svg primitives
export const Svg = ({
  width,
  height,
  viewBox,
  style = {},
  children,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    style={mergeStyles(style)}
    xmlns='http://www.w3.org/2000/svg'
    {...rest}
  >
    {children}
  </svg>
)

export const Path = ({
  d,
  // fill = 'black',
  stroke = 'none',
  style = {},
  ...rest
}) => (
  <path
    d={d}
    // fill={fill}
    stroke={stroke}
    style={mergeStyles(style)}
    {...rest}
  />
)

export const Circle = (props) => <circle {...props} />
export const Rect = (props) => <rect {...props} />
export const Line = (props) => <line {...props} />
export const G = ({ children, ...rest }) => <g {...rest}>{children}</g>

// stylesheet shim
export const StyleSheet = {
  create: (styles) => styles
}

// font shim
export const Font = {
  register: () => {},
  registerHyphenationCallback: () => {}
}
